/* global window */
import querystring from 'querystring';
export default function addReferrer(query, req) {
  const _pathname = req ? req.path : window.location.pathname;
  const searchString = req ? `?${querystring.stringify(req.query)}` : window.location.search;

  // Throw error if we don't have what we need to build a url
  if (!_pathname) {
    throw Error('atc-paths needs a pathname to generate a referrer. Most likely you have forgotten to pass the req object in the options to allow server generation on the server.');
  }
  return {
    ...query,
    referrer: _pathname + searchString
  };
}